/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useCallback, useState } from 'react';
import type { PropsWithChildren } from 'react';

import { FullscreenDialog } from '@coursera/cds-core';

import { WidgetExpandButton } from 'bundles/widget/components/cds/WidgetInPlaceModalHeader';

import _t from 'i18n!nls/native-widgets';

const { Header, Content } = FullscreenDialog;

const styles = {
  content: css`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 100%;
  `,
  expandRow: css`
    margin-top: var(--cds-spacing-200);
  `,
  dialogContent: css`
    padding: 0;
    height: 100%;
  `,
};

type ExpandableContainerProps = PropsWithChildren<{
  showPopupButton?: boolean;
  renderCustomContainer?: (onExpand: () => void) => React.ReactNode;
}>;

export const ExpandableContainer = ({ children, showPopupButton, renderCustomContainer }: ExpandableContainerProps) => {
  const [expanded, setExpanded] = useState(false);

  const onExpand = useCallback<() => void>(() => setExpanded(true), []);
  const onCollapse = useCallback<() => void>(() => setExpanded(false), []);

  return (
    <React.Fragment>
      {!expanded && (
        <React.Fragment>
          <div css={styles.content}>{children}</div>

          {showPopupButton &&
            (renderCustomContainer ? (
              renderCustomContainer(onExpand)
            ) : (
              <div css={styles.expandRow}>
                <WidgetExpandButton onClick={onExpand} label={_t('Expand preview.')} />
              </div>
            ))}
        </React.Fragment>
      )}

      <FullscreenDialog open={expanded} onClose={onCollapse} contentWidth="100%">
        <Header />
        <Content css={styles.dialogContent}>{children}</Content>
      </FullscreenDialog>
    </React.Fragment>
  );
};
